import { Message } from './message';
import { TopicMessage } from './topic-message';

export class SubscriptionMessage extends TopicMessage {
  Subscription: string;
}
